export const visit = (vm, at) => {
at({ "ca-es": { "conversations-visitor-experience-components": { "code-splitting": { "error": { "title": "Hi ha hagut on problema de connexi\xF3 de xarxa.", "message": "Comprova la connexi\xF3 i torna-ho a provar.", "button": "Torna-ho a provar" } } } } });
};